<template>
  <div class="main">
    <my_menu active_name="0-0" :open_active="['0']"></my_menu>

    <div class="content">
      <div class="options">
        <Button
          style="font-size: 10px"
          size="small"
          @click="add_sys_show = true"
          icon="ios-add-circle-outline"
          >添加系统</Button
        >
      </div>
      <div class="table_box">
        <Spin fix v-if="table_lading"></Spin>
        <Table
          size="small"
          :height="windowHeight - 80"
          border
          :columns="columns"
          :data="tab_data"
        ></Table>
      </div>
    </div>
  </div>

  <Modal width="420" v-model="add_sys_show" title="添加系统" :footer-hide="true">
    <div>
      <Form ref="add_sys" :model="add_sys_data" :rules="add_sys_rules" inline>
        <FormItem prop="name">
          <div class="form_item">
            <div class="form_item_title">系统名称：</div>
            <Input
              style="width: 250px"
              type="text"
              v-model="add_sys_data.name"
              placeholder="系统名称"
            >
            </Input>
          </div>
        </FormItem>
        <!-- <FormItem prop="dx_sys_id">
                    <div class="form_item">
                        <div class="form_item_title">大象系统ID：</div>
                        <Input style="width: 250px" type="text" v-model="add_sys_data.dx_sys_id" placeholder="大象系统ID">
                        </Input>
                    </div>
                </FormItem> -->
        <div class="add_sys_button">
          <Button type="primary" @click="add_sys_ok('add_sys')">确认添加</Button>
        </div>
      </Form>
    </div>
  </Modal>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      menu_show: false,
      columns: [],
      table_lading: true,
      tab_data: [],
      add_sys_show: false,

      add_sys_data: {
        name: "",
      },
      add_sys_rules: {
        name: [
          { required: true, message: "请输入系统名称", trigger: "blur" },
          { type: "string", min: 2, message: "请输入系统名称", trigger: "blur" },
        ],
      },
    };
  },

  mounted() {
    this.window_change();
    this.get_sys_list();
  },

  methods: {
    //添加系统确认
    add_sys_ok(name) {
      var that = this;
      this.$refs[name].validate((valid) => {
        console.log(valid);
        if (valid) {
          var obj = {
            name: that.add_sys_data.name,
          };
          http("post", process.env.VUE_APP_HOST + "/authority_manage/add_sys", obj, true)
            .then((res) => {
              if (res.code == 0) {
                that.$Message.success({
                  content: res.msg,
                  duration: 3,
                });
                that.add_sys_show = false;
                that.get_sys_list();
              } else {
                that.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            })
            .catch((res) => {
              that.$Message.error({
                content: "请求超时",
                duration: 3,
              });
            });
        } else {
        }
      });
    },

    //点击添加
    click_add_sys(e) {
      console.log(e);
      this.add_sys_show = true;
    },

    //获取系统列表
    get_sys_list() {
      var that = this;
      var obj = {};
      this.table_lading = true;
      http("post", process.env.VUE_APP_HOST + "/authority_manage/sys_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.tab_data = res.data.sys_list;
            that.columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_lading = false;
        })
        .catch((res) => {
          that.table_lading = false;
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.table_box {
  position: relative;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  padding: 10px;
  width: calc(100% - 220px);
  background-color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
